import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const UpdateMeterForm = () => {
  const [errors, setErrors] = useState({})
  const [categoryOptions, setCategoryOptions] = useState([])
  const [statusOptions, setStatusOptions] = useState([])
  const [locationOptions, setLocationOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
    category_id: null,
    location_id: null,
    serial_number: "",
    initial_reading: "",
    lock_number: null,
    remark: null,
    status: "",
    public_id: "",
  })

  const {category_id, location_id, serial_number, initial_reading, lock_number, remark, status, public_id} = formData

  const navigate = useNavigate()
  const location = useLocation()
  const status_list = [{id: 1, key: "active", name: "Active"}, {id: 2, key: "inactive", name: "Inactive"}]

  useEffect(() => {

    if (location.state){
        const {meter} = location.state
        const status_obj = status_list.find(status => status.name === meter.status)
        setFormData({
            category_id: meter.category_id,
            serial_number: meter.serial_number,
            initial_reading: Number.parseInt(meter.initial_reading),
            lock_number: meter.lock_number,
            remark: meter.remark,
            status: status_obj.id,
            public_id: meter.public_id,
            location_id: meter.location_pk,
        })
    }

  }, [location]);

  // 4. Watch for formData.location_id and then load location options
  useEffect(() => {
    if (formData.location_id) {
    loadLocationOptions(formData.location_id);
    }
}, [formData.location_id]);
  

  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()
    
      const statu_name = status_list[formData.status - 1].name
      const payload = {location_id, category_id, serial_number, initial_reading, lock_number, remark, status: statu_name}
        updateMeter(payload)
  }
  
  // update meter
  const updateMeter = async (payload) => {
      setIsLoading(true)
      try {
          const response = await Server.put(`/meters/${public_id}`, payload)
          if (response.status === 200){
              navigate('/meters-serverside')
              setIsLoading(false)
              toast.success('Successfully updated')
          }else{
              toast.error(response.data?.detail)
          }
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422) {
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            toast.error(error.response.data.detail);
            navigate('/');
        }else {
            toast.error(error.response?.data?.detail);
        }
      }
  }

  // Load options dynamically from a remote source
    const loadLocationOptions = async (query) => {
        try {
            const params = { q: query };
            const response = await Server.get('/options/locations', {params});
            setLocationOptions(response.data)
            return response.data;
        } catch (error) {
        return [];
        }
    };

    // Load options dynamically from a remote source
    const loadOptions = async (url, query, setOptions) => {
        const params = { q: query };

        setStatusOptions(status_list.map(status => ({
            id: status.id,
            key: status.key,
            name: status.name
        })));

        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Meter Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="location_id"
                                label="Customer"
                                value={locationOptions.find((option) => option.value === formData.location_id)?.value ?? 0}
                                onChange={onChange}
                                loadOptions={loadLocationOptions}
                                options={locationOptions}
                                placeholder="Start typing to search..."
                                error={errors.location_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Meter Serial Number (Optional)"
                                name="serial_number"
                                type="text"
                                label="Serial Number"
                                value={serial_number}
                                onChange={onChange}
                                error={errors.serial_number}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Meter Current Reading"
                                name="initial_reading"
                                type="number"
                                label="Initial Reading"
                                value={initial_reading}
                                onChange={onChange}
                                error={errors.initial_reading}
                            />
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-3">
                            <NullableInput
                                placeholder="Box Lock Number (Optional)"
                                name="lock_number"
                                type="text"
                                label="Lock Number"
                                value={lock_number}
                                onChange={onChange}
                                error={errors.lock_number}
                            />
                        </div>
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="category_id"
                                label="Category"
                                value={categoryOptions.find((option) => option.value === formData.category_id)?.value ?? 0}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('meter-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectField
                                name="status"
                                label="Status"
                                value={parseInt(status)}
                                options={statusOptions}
                                onChange={onChange}
                                error={errors.status}
                            />
                        </div>
                        <div className="col-md-3">
                            <NullableInput
                                placeholder="Meter Remarks (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Meter" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateMeterForm
